// extracted by mini-css-extract-plugin
export var title = "page-title-module--title--ltVAm";